import React from 'react';
import WorkExperience from './WorkExperience';

const Timeline = () => {
  return (
    <div className="tab-content">
      <WorkExperience />
    </div>
  );
};

export default Timeline; 